import styled from 'styled-components';
import {GameBadgeDefaultBox} from './game-badge.default.box';

export const GameBadgeCasino777Box = styled(GameBadgeDefaultBox)`
    height: 28%;
    width: 28%;
`;